<template>
    <div>
        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="quotes"
                    hide-actions
                    >
                    <template slot="items" slot-scope="props">
                        <td class="px-1 text-no-wrap">
                            <a href="#" @click.prevent="$emit('viewQuote', props.item.id)">{{ props.item.num }}</a>
                        </td>
                        <td class="px-1 text-no-wrap" :class="jobColor(props.item.statusId)">{{ props.item.statusId }}</td>
                        <td class="px-1">{{ props.item.facilityName }}</td>
                        <td class="px-1 text-xs-center text-no-wrap">{{ props.item.quoteDate }}</td>
                        <td class="px-1 text-xs-center">
                            <!-- {{ props.item.totalAmount | toCurrency  }} -->
                            {{ formatCurrency((!props.item.totalAmount? 0 : props.item.totalAmount), props.item.totalAmountCurrnIdx) }}
                        </td>
                        <td>{{props.item.facilityAcctNo}}</td>
                        <td>{{props.item.contactName}}</td>
                        <td>{{props.item.phone}}</td>
                        <td>{{props.item.salesRep.name}}</td>
                        <td>{{props.item.csRep.name}}</td>
                        <td>{{props.item.isRep.name}}</td>
                        <!-- <td>
                            <v-btn small color="primary" @click.prevent="$emit('onEditItem', props.item)" >Edit</v-btn>
                            <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn>
                        </td> -->
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>

    </div>
</template>
<script>
import ctlQuoteItemEdit from '@/components/public/ctlQuoteItemEdit'
export default {
    props: ['quotes'],
    components: {
    },
    data() {
        return {
            headers: [
                { text: '#', sortable: false},
                { text: 'Status', sortable: false},
                { text: 'Facility', sortable: false},
                { text: 'Quote Date' , sortable: false},
                { text: 'Total Amt.' , sortable: false, align: 'center'},
                { text: 'Acct. #' , sortable: false},
                { text: 'Contact' , sortable: false},
                { text: 'Phone' , sortable: false},
                { text: 'Sales Rep.' , sortable: false},
                { text: 'CS Rep.' , sortable: false},
                { text: 'IS Rep.' , sortable: false},
                // { text: 'QTY', sortable: false, class: ['px-1']},
                // { text: 'PRICE LEVEL' , sortable: false},
                // { text: 'DISCOUNT' , sortable: false},
                // { text: 'TOTAL' , sortable: false, align: 'right'},
                // { text: 'Notes', value: 'notes', sortable: false, class: ['px-1']},
                // { text: '', sortable: false}
            ],
        }
    },
    computed: {
    },
    methods: {
        jobColor (jobStatus) {
            if (jobStatus === 'Cancelled') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'Lost') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'NeedMoreInfo') {
                return 'orange--text lighten-3'
            }
            if (jobStatus === 'Editing') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Processing' 
                || jobStatus === 'DiscountApproved') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Revising') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Won') {
                return 'green--text lighten-3'
            }
            if (jobStatus === 'SentToCustomer') {
                return 'purple--text lighten-3'
            }
            if (jobStatus === 'WaitingForProcess') {
                return 'blue--text lighten-3'
            }
        },

    }
}
</script>
